// extracted by mini-css-extract-plugin
module.exports = {"pageName":"StaffFood_pageName__37cas"};